import globalConfig from '@utiles/globalConfig';
import { getSessionInfo } from '@plugins/biPoint/sessionId';

/** 取第一个非空字符串；全空则返回 '' */
function firstNonEmpty(...values) {
  for (let i = 0; i < values.length; i++) {
    const raw = values[i];
    if (raw == null) continue;
    const text = String(raw).trim();
    if (text) return text;
  }
  return '';
}

function hrefParam(name) {
  return globalConfig.getHrefParam(name);
}

function cookieParam(name) {
  return globalConfig.getCookie(name);
}

/**
 * 可配置自助表单 submitSelfServiceForm 的上下文字段。
 * 优先级：当前 URL（含 hash）→ 进页 session → Cookie（个别字段见注释）。
 * 无值则不出现在返回对象中。
 */
export function buildSelfServiceSubmitContextParams({ curLang } = {}) {
  const entry = globalConfig.getAllWebviewEntryParams() || {};
  const context = {};

  // zone: URL → curLang → Cookie
  const zone = firstNonEmpty(hrefParam('zone'), curLang, cookieParam('zone'));
  if (zone) context.zone = zone;

  // sid: URL → Cookie → 埋点 session
  const sid = firstNonEmpty(
    hrefParam('sid'),
    cookieParam('sid'),
    getSessionInfo()?.sid
  );
  if (sid) context.sid = sid;

  // role_id: URL role_id|roleId → entry roleId → Cookie
  const roleId = firstNonEmpty(
    hrefParam('role_id'),
    hrefParam('roleId'),
    entry.roleId,
    cookieParam('role_id'),
    cookieParam('roleId')
  );
  if (roleId) context.role_id = roleId;

  // country: URL → entry → Cookie
  const country = firstNonEmpty(
    hrefParam('country'),
    entry.country,
    cookieParam('country')
  );
  if (country) context.country = country;

  // device_name ← phoneModel（及字面 device_name）
  const deviceName = firstNonEmpty(
    hrefParam('device_name'),
    hrefParam('phoneModel'),
    entry.phoneModel,
    cookieParam('phone_model'),
    cookieParam('phoneModel'),
    cookieParam('device_name')
  );
  if (deviceName) context.device_name = deviceName;

  // package_version ← packageVersion
  const packageVersion = firstNonEmpty(
    hrefParam('package_version'),
    hrefParam('packageVersion'),
    entry.packageVersion,
    cookieParam('package_version'),
    cookieParam('packageVersion')
  );
  if (packageVersion) context.package_version = packageVersion;

  // chat_id: search+hash 的 chatId|chat_id
  const chatId = firstNonEmpty(hrefParam('chatId'), hrefParam('chat_id'));
  if (chatId) context.chat_id = chatId;

  return context;
}
